import { render, staticRenderFns } from "./SetAccountWidget.vue?vue&type=template&id=50084295&"
import script from "./SetAccountWidget.vue?vue&type=script&lang=js&"
export * from "./SetAccountWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports